import React, { useState } from "react";
import { Link } from "react-router-dom";
import { addNewAgency, superAdminAgencyDetails } from "../common/allLinks";
import CommonSearchBar from "../common/CommonSearchBar";
import LinkBorderCommonButton from "../common/LinkBorderCommonButton";

export default function SuperAdminDashboardAgencies() {
  const [values, setValues] = useState({
    searchStrSuperAdminAgencies: "",
  });

  /*===========================================
              handler
  ===========================================*/

  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnClickSearchButton = (e) => {
    e.preventDefault();
    console.log(values.searchStrSuperAdminAgencies);
  };

  /*===========================================
              main
  ===========================================*/
  return (
    <>
      <h3 className="font-16-NunitoSans-600 mb-38 color-white-35">
        List of Agencies
      </h3>
      <CommonSearchBar
        name="searchStrSuperAdminAgencies"
        value={values.searchStrSuperAdminAgencies}
        onChange={handleOnChange}
        onClickSearchButton={handleOnClickSearchButton}
      />

      {[1, 2].map((data, index) => (
        <div
          key={index}
          className="custom-d-flex justify-content-between mt-sa-list-card"
        >
          <div className="mt-sa-list-card__colm1 d-flex align-items-center mr-30">
            <div className="mt-sa-list-card__colm1__imgBlock flex-shrink-0">
              {/* <img src="" alt="" /> */}
            </div>
            <span className="font-24-NunitoSans-600 mt-sa-list-card__colm1__text1">
              Agency Name
            </span>
          </div>
          <div className="mt-sa-list-card__colm2 d-flex flex-shrink-0 align-items-center">
            <LinkBorderCommonButton
              extraClassName="login-btn-link--preview login-btn-link--preview--client mr-30"
              linkText="View Details"
              linkPath={superAdminAgencyDetails}
            />
            <Link to={superAdminAgencyDetails}>
              <div
                className="mt-sa-list-card__colm2-btn"
                onClick={() =>
                  localStorage.setItem(
                    "activeSuperAdminDashboardAgencyDetailsTabIndex",
                    1
                  )
                }
              >
                <img src="/img/desktop/icons/gray-document-icon.svg" alt="" />
                <span>Requirement History</span>
              </div>
            </Link>
            <Link to={addNewAgency} state={{ isEditForm: true }}>
              <div className="mt-sa-list-card__colm2-btn">
                <img src="/img/desktop/icons/gray-pencil-icon.svg" alt="" />
                <span>Edit</span>
              </div>
            </Link>
            <button className="mt-sa-list-card__colm2-btn">
              <img src="/img/desktop/icons/gray-trash-icon.svg" alt="" />
              <span>Delete</span>
            </button>
          </div>
        </div>
      ))}
    </>
  );
}
